import Attachment from 'components/ui/Attachment';
import NavButton from 'components/ui/Button/NavButton';
import ModalWarning from 'components/ui/ModalWarning';
import Participants from 'components/ui/Participants';
import StepNav from 'components/ui/StepNav';
import StepTitle from 'components/ui/StepTitle';
import { AuthContext } from 'context/AuthContext';
import { useModal } from 'context/ModalContext/Modal.context';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { uploadFile } from 'services/file.service';
import { editIndication, editRealization, newRealization } from 'services/realization.service';
import { Team, TeamData } from 'types/realization';
import { clearRegistrationUser } from 'utils/fns';

import './style.scss';

const Subscribe = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, rule, updateNotifications } = useContext(AuthContext);
    const { showModal, closeModal } = useModal();

    const [subStepActive, setSubSteActive] = useState(1);

    const [errorMessage, setErrorMessage] = useState<string>('');
    const [sending, setSending] = useState(false);
    const [allowedNext, setAllowedNext] = useState(false);
    const [currentFile, setCurrentFile] = useState<File | null>(null);
    const [videoEmbedUrl, setVideoEmbedUrl] = useState('');
    const [step, setStep] = useState<'ATTACHED' | 'SELECTPERSON'>('ATTACHED');
    const [participantsItens, setParticipantItens] = useState<any>();

    const [ruleUrl, setRuleUrl] = useState('');

    const [currentTeam, setCurrentTeam] = useState<TeamData[]>([]);
    const [teamMessage, setTeamMessage] = useState<Team[]>([]);

    const [isEdit, setIsEdit] = useState(false);

    const data = location.state?.data;

    useEffect(() => {
        if (!user) {
            return;
        }
        console.log('current_data', data);
        if (!!location.state.data.allowNextButton) {
            setIsEdit(true);
        }
        if (!!location.state.action && location.state.action === 'indication') {
            setStep('SELECTPERSON');
            setAllowedNext(true);
        }

        if (data.team_data) {
            setCurrentTeam(data.team_data);
        }

        if (data.team) {
            setTeamMessage(data.team);
        }

        if (data.realization) {
            setCurrentTeam(data.realization.team_data);
        }
        console.log(currentTeam);
    }, [location.state, user]);

    const handleFileSelect = (file: File | null) => {
        setCurrentFile(file);
        if (!file) {
            setAllowedNext(false);
        }
        if (file) console.log('Arquivo selecionado:', file);
    };

    useEffect(() => {
        if (!!rule) {
            setRuleUrl(rule.url);
        }
    }, [rule]);

    useEffect(() => {
        const url = videoEmbedUrl;
        if (!!location.state.action && location.state.action === 'indication') {
            setAllowedNext(true);
        } else {
            if (url && url.trim().length > 0) {
                setVideoEmbedUrl(url);
                setAllowedNext(true);
                console.log('URL válida, botão habilitado.');
            } else {
                setVideoEmbedUrl('');
                setAllowedNext(false);
                console.log('URL inválida, botão desabilitado.');
            }
        }
    }, [videoEmbedUrl]);

    const handleVideoSelect = (url: string) => {
        setVideoEmbedUrl(url);
    };

    const handleProgressComplete = () => {
        setAllowedNext(true);
    };

    const handleNext = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

        if (isEdit) {
            handlerSend();
        } else {
            if (step === 'ATTACHED') {
                setSubSteActive(2);
                setStep('SELECTPERSON');
            } else {
                if (participantsItens.length < 2) {
                    showModal(
                        'limit-participants',
                        <ModalWarning title={`Ops`} description={`Para cadastrar a realização, você deve informar ao menos 2 participantes!`} btnText="Continuar" onClose={closeModal} />,
                        'participant-limit'
                    );
                } else {
                    showModal(
                        'accept-terms',
                        <ModalWarning
                            rule={ruleUrl}
                            title={`Sua inscrição está quase pronta!`}
                            subTitle={'Confirme abaixo algumas informações importantes antes de finalizá-la.'}
                            needInfo={true}
                            needRule={true}
                            description={
                                <>
                                    <div className="flex flex-col gap-3">
                                        <p>Declaro que li e concordo com os termos estabelecidos na 403-1, item 8.</p>
                                        <p>
                                            Estou ciente sobre os prazos de inscrição, requisitos de participação, critérios de avaliação e os meus direitos e deveres como participante do Prêmio BB.
                                        </p>
                                        <p>Comprometo-me a fornecer informações precisas e completas, além de seguir todas as regras e regulamentos da premiação.</p>
                                        <p>Autorizo a organização a usar minha imagem em fotos ou vídeos, bem como meus dados pessoais, para fins de divulgação.</p>
                                        <p>
                                            Tenho conhecimento de que será realizada a verificação dos requisitos de impedimentos por alguma das situações listadas na IN 403-1, item 1.6, com base na
                                            situação apurada no primeiro dia útil após o encerramento das inscrições.
                                        </p>
                                    </div>
                                </>
                            }
                            btnText="Finalizar inscrição"
                            onBackButton={closeModal}
                            hasBackButton={true}
                            onClose={handlerSend}
                        />,
                        'accept-terms'
                    );
                }
            }
        }
    };

    const handleConfirm = () => {
        showModal(
            'confirm',
            <ModalWarning
                rule={rule?.url && rule?.url}
                title={isEdit ? 'Atualizada com sucesso' : 'Sua inscrição foi realizada!'}
                description={
                    isEdit
                        ? 'Sua inscrição foi atualizada com sucesso!'
                        : 'Lembre-se de avisar aos demais participantes da realização sobre a inscrição para que eles possam confirmar suas respectivas participações no Prêmio BB 2024. '
                }
                btnText="Fechar"
                onClose={() => {
                    closeModal();
                    updateNotifications();
                    navigate('/realizations/success');
                }}
            />,
            'confirm-subscribed'
        );
    };

    const handlerSend = async () => {
        setSending(true);
        try {
            closeModal();
            if (!user) return;

            let document = [];

            if (currentFile) {
                const fileData = await uploadFile(currentFile);
                document.push({
                    file: fileData.url,
                    nameFile: fileData.filename,
                    type: 'file'
                });
            }

            if (videoEmbedUrl) {
                document.push({
                    file: videoEmbedUrl,
                    type: 'video'
                });
            }

            if (!!user) {
                let currentPlayer = clearRegistrationUser(user?._id);

                if (isEdit) {
                    if (data.isMy) {
                        let body = {
                            _id: data.id_inscricao,
                            id_realizacao: data.id_realizacao,
                            title: data.title,
                            dt_aceite: data.dt_aceite,
                            player: currentPlayer,
                            rawPlayer: user?._id,
                            player_name: user?.name
                        };

                        if (document.length > 0) {
                            body = { ...body, ...{ documento: document } };
                        }

                        if (document.length === 0) {
                            setErrorMessage('Nenhum arquivo selecionado.');
                            return;
                        }

                        await editRealization(body, { _id: data._id });
                    }
                } else {
                    const notificationId = !!location.state.notificationId ? location.state.notificationId : '';
                    if (location.state.action === 'indication') {
                        let body = {
                            _id: !!notificationId ? location.state.data.inscricao_part_id : location.state.data._id,
                            player: currentPlayer,
                            rawPlayer: user?._id,
                            id_inscricao: data.id_inscricao,
                            id_realizacao: location.state.data.realization._id,
                            dt_aceite: new Date(),
                            concorrentes_info: participantsItens
                        };

                        await editIndication(body, notificationId);
                    } else {
                        let body = {
                            id_realizacao: location.state.data._id,
                            title: data.title,
                            dt_aceite: new Date(),
                            rawPlayer: user?._id,
                            player: currentPlayer,
                            player_name: user?.name
                        };
                        if (document.length > 0) {
                            body = { ...body, ...{ documento: document } };
                        }

                        await newRealization(body, location.state.data, participantsItens, notificationId);
                    }
                }
            }
            handleConfirm();
        } catch (error: any) {
            console.log(error);
        } finally {
            setSending(false);
        }
    };

    const handlerBack = async () => {
        if (step === 'SELECTPERSON') {
            setStep('ATTACHED');
            setSubSteActive(2);
        }

        if (step === 'ATTACHED') {
            navigate('/realizations');
            setSubSteActive(1);
        }
    };

    return (
        <div className="relative">
            <StepNav currentStep={1} activeSubStep={subStepActive} />
            <StepTitle
                title={step === 'ATTACHED' ? 'Anexe documentação sobre a realização inscrita.' : 'Abaixo, indique 5 participantes da realização cadastrada para concorrerem à premiação individual. '}
                description={
                    step === 'ATTACHED'
                        ? 'Lembre-se: você pode anexar um PDF sobre o projeto ou incorporar um vídeo com um pitch de até 3 minutos. Você não poderá ir para a próxima etapa sem adicionar ao menos um dos dois documentos.'
                        : 'Lembre-se da participação de cada um para o sucesso da entrega da realização. Caso a realização passe para a segunda etapa, a iniciativa receberá o prêmio no valor de R$ 50.000,00 para ser dividido entre todos os participantes de forma igualitária.'
                }
            />

            {step === 'ATTACHED' && (
                <Attachment
                    currentDocument={data.documento}
                    onProgressComplete={handleProgressComplete}
                    allowedTypes={['application/pdf']}
                    maxFizeSize={3}
                    onFileSelect={handleFileSelect}
                    onVideoSelect={handleVideoSelect}
                />
            )}

            {step === 'SELECTPERSON' && (
                <Participants
                    team={teamMessage}
                    options={currentTeam}
                    onSelected={(itens) => {
                        const list = itens?.map((item) => {
                            return {
                                registration: item.chave,
                                player: item._id,
                                name: item.nome
                            };
                        });

                        setParticipantItens(list);
                    }}
                    selected={isEdit ? data.concorrentes_info : []}
                    minSelected={currentTeam.length < 5 ? currentTeam.length : 5}
                    limitSelected={5}
                    onBack={function (): void {
                        console.log('onback');
                    }}
                    onNext={handleNext}
                    isNextDisabled={!(Array.isArray(participantsItens) && ((currentTeam.length >= 5 && participantsItens.length >= 5) || (currentTeam.length < 5 && participantsItens.length >= 2)))}
                />
            )}
            <div className={`actions flex justify-end gap-8 my-8 mx-4 ${step === 'SELECTPERSON' ? 'positioned' : ''}`}>
                <p className="text-base text-right text-red-300">{errorMessage}</p>
                {location.state.action !== 'indication' && <NavButton text="Voltar" bgColor="#E0E9FF" onClick={handlerBack} />}
                {isEdit ? (
                    <NavButton
                        text={step === 'ATTACHED' && !isEdit ? `Ir para a próxima etapa` : `Atualizar ${location.state.action === 'indication' ? 'indicação' : 'inscrição'}`}
                        bgColor="#FCFC30"
                        onClick={handleNext}
                        isLoading={sending}
                    />
                ) : (
                    <NavButton
                        text={step === 'ATTACHED' ? `Ir para a próxima etapa` : `Finalizar ${location.state.action === 'indication' ? 'indicação' : 'inscrição'}`}
                        bgColor="#FCFC30"
                        disabled={
                            step === 'SELECTPERSON'
                                ? !(Array.isArray(participantsItens) && ((currentTeam.length >= 5 && participantsItens.length >= 5) || (currentTeam.length < 5 && participantsItens.length >= 2)))
                                : !allowedNext
                        }
                        onClick={handleNext}
                        isLoading={sending}
                    />
                )}
            </div>
        </div>
    );
};

export default Subscribe;
